module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"hotTip":"Click the date title at the top of the date picker to navigate through months and years","yes":"Yes","no":"No"},"de":{"hotTip":"Tipp: Klicken Sie oben in der Datumsauswahl auf den Datumstitel, um durch Monate und Jahre zu navigieren","yes":"Ja","no":"Nein"}}')
  delete Component.options._Ctor
}
